import styled from 'styled-components';
import { Box, Button } from '@rsos/components/capstone/base';

export const ButtonWrapper = styled(Box).attrs({
  bg: 'inherit',
  p: '1px',
  m: '5px',
})`
  background-image: linear-gradient(
    to right,
    rgb(99, 102, 241),
    rgb(139, 92, 246),
    rgb(217, 70, 239)
  );
  border-radius: 5px;
`;

export const AskHarmonyButton = styled(Button)`
  background-image:
    linear-gradient(
      ${({ theme }) => theme.colors.background},
      ${({ theme }) => theme.colors.background}
    ),
    linear-gradient(to right, #6366f1, #8b5cf6, #d946ef);
  border: none;
  background-origin: border-box;
  background-clip: padding-box, border-box;

  &:active {
    background-image:
      linear-gradient(
        ${({ theme }) => theme.colors.background},
        ${({ theme }) => theme.colors.background}
      ),
      linear-gradient(to right, #6366f1, #8b5cf6, #d946ef);
    border: none;
  }
`;
